import { render } from "./Contadores.vue?vue&type=template&id=2e9eb52c&scoped=true"
import script from "./Contadores.vue?vue&type=script&lang=js"
export * from "./Contadores.vue?vue&type=script&lang=js"

import "./Contadores.vue?vue&type=style&index=0&id=2e9eb52c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9eb52c"]])

export default __exports__